import React from "react";
import MainLayout from "../layouts/MainLayout/index";
import AdvertisingLayout from "../layouts/AdvertisingLayout/index";
import { routes } from "../routes/routes";
import { useRoutes } from "react-router-dom";
import { Container } from "./style";
import { checkoutRender } from "../services/paymentServices";
var App = function () {
    var element = useRoutes(routes);
    checkoutRender();
    return (React.createElement(Container, null,
        React.createElement(MainLayout, null, element),
        React.createElement(AdvertisingLayout, null)));
};
export default App;
